import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  display: grid;
  grid-template-columns: repeat(6, 40px);
  gap: 10px;
  justify-content: center;
  margin-bottom: 4px;
`;

export default Wrapper;
